import api from "../../Api/feathers-client";

// Return user's name in normal formate from json formate
export const formateName = (nameJson) => {
  let name = "";
  if (nameJson.firstname) {
    name += nameJson.firstname;
  }
  if (nameJson.middlename) {
    name += " " + nameJson.middlename;
  }
  if (nameJson.lastname) {
    name += " " + nameJson.lastname;
  }

  return name;
};

// Return user's name in json formate from normal formate
export const nameToJson = (name) => {
  let nameArray = name.split(" ");
  let nameJson = {};
  if (nameArray.length > 0) {
    nameJson["firstname"] = nameArray[0].trim();
  } else {
    nameJson["firstname"] = "";
  }
  if (nameArray.length > 1) {
    nameJson["lastname"] = nameArray[nameArray.length - 1].trim();
  } else {
    nameJson["lastname"] = "";
  }
  if (nameArray.length > 2) {
    nameArray.pop();
    nameArray.shift();
    nameJson["middlename"] = nameArray.join(" ").trim();
  } else {
    nameJson["middlename"] = "";
  }

  return nameJson;
};

// Call backend service to update user
export const updateUser = async (data, uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").patch(null, data, {
        query: {
          uid,
          site_uuid,
        },
      });

      resolve({
        status: 200,
        message: "User Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
